<template>
  <div class="wm-field-input">
    <input :id="id"
           :class="['multitext', 'card-number', {'first': part === 1}]"
           :type="isMobile ? 'number' : 'text'"
           :disabled="disabled"
           :readonly="readonly"
           :maxlength="isMobile ? false : 4"
           :max="isMobile ? 9999 : false"
           v-model="localValue"
           pattern="^[0-9_%]*$"
           inputmode="numeric"
           @blur="onBlur"
           @keyup.delete="onDelete"
           @keypress="onKeyPress"
           @input="isValidInput"
           @paste="onPaste">

    <ul v-if="!parentError && showValidationErrors && $v.localValue.$error"
        class="ui-state-error"
        role="alert"
        aria-atomic="true"
        aria-live="polite">
      <li>{{ $t('engraved-id.validation.part') }}</li>
    </ul>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
import deviceMixin from '../../../mixins/device'

export default {
  name: 'EngravedIdPart',
  mixins: [validationMixin, deviceMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    part: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    parentError: {
      type: Boolean,
      default: false
    },
    showValidationErrors: {
      type: Boolean,
      default: true
    },
    validateOnBlur: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  computed: {
    id: function () {
      return `engravedId_${this.part - 1}`
    }
  },
  watch: {
    value: function (value) {
      this.localValue = value
    },
    localValue: function (value) {
      this.$emit('input', value)
    },
    parentError: function () {
      this.$v.$reset()
    }
  },
  methods: {
    onBlur: function () {
      if (this.validateOnBlur) {
        this.$v.localValue.$touch()
      }
    },
    onDelete: function () {
      if (!this.localValue) this.$emit('previous')
    },
    onPaste: function (e) {
      this.$emit('paste', e)
    },
    isControlKeyPress: function (e) {
      if (e.key) {
        return e.key.length > 1
      }

      if (e.which) {
        return String.fromCharCode(e.which).length < 1
      }
    },
    matchesRegex: function (input) {
      return /^[0-9_%]*$/.test(input)
    },
    onKeyPress: function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'v') {
        return
      }

      // if typing non-control characters, only numerical ones are accepted
      // limit input to 4 characters
      if (
        !(this.matchesRegex(e.key || String.fromCharCode(e.which)) || this.isControlKeyPress(e)) ||
        (this.matchesRegex(e.key || String.fromCharCode(e.which)) && this.localValue.length === 4)
      ) {
        e.preventDefault()
      }
    },
    isValidInput: function (e) {
      // limit input to 4 characters on mobile devices
      if (this.isMobile && this.matchesRegex(e.data) && this.localValue.length >= 4) {
        this.localValue = this.localValue.substr(0, 4)
      }
    }
  },
  validations: {
    localValue: {
      required,
      numeric,
      minLength: minLength(4),
      maxLength: maxLength(4)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/EngravedIdPart.vue